import { useCallback } from "react";

import { debounce } from "lodash";

import { notifyError } from "utils";

/**
 * Returns a callback that can be used to protect actions based on access permissions.
 */
export const useProtectedAction = ({ hasAccess, errorMessage, errorId }) => {
	const options = errorId ? { toastId: errorId } : {};

	const debouncedNotifyError = useCallback(
		debounce((message, opts) => {
			notifyError(message, null, opts);
		}, 500),
		[]
	);

	return useCallback(
		(e) => {
			if (!hasAccess) {
				e.preventDefault();
				e.stopPropagation();
				debouncedNotifyError(
					errorMessage || "You do not have permission to access this resource.",
					options
				);
			}
		},
		[ hasAccess, errorMessage, options, debouncedNotifyError ]
	);
};